export const bangkokKlookAttractions = {
  'sea-life':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1088903&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F357-sea-life-bangkok-ocean-world-bangkok%2F',
  'safari-world':
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1088972&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F365-safari-world-bangkok%2F',
  bustaurant:
    'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1111542&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F27212-thai-food-sightseeing-bus-experience-bangkok%2F%3Fspm%3DSearchResult.SearchResult_LIST%26clickId%3D7e25ecb2eb',
};
